import { merge, object_map } from "@pdfking/rfunc"
import { defineComponent } from "vue"
import autocomplete from "../constants/autocomplete"
import Double from "./Double"

export default defineComponent({
  computed: {
    options() {
      const content = (autocomplete as any)[this.autocomplete]

      if (content) {
        return merge({}, this.extra || {}, {
          [content.title || ""]: object_map(
            (c: { name: string }) => c.name,
            (c: { objects: unknown }) => c.objects,
            content.objects
          ),
        })
      }
      return this.extra || {}
    },
  },
  emits: ["selection"] as const,
  props: [
    "name",
    "value",
    "autocomplete",
    "extra",
    "size_1",
    "size_2",
    "size",
    "manual_size",
  ] as const,
  render() {
    return (
      <Double
        name={this.name}
        options={this.options}
        size_1={this.size_1}
        size_2={this.size_2}
        value={this.value}
        onSelection={(v: string) => this.$emit("selection", v)}
      >
        {{
          buttons: () => this.$slots.buttons?.(),
        }}
      </Double>
    )
  },
})
